<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <specialEdition :type='type' :id='id'></specialEdition>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import specialEdition from '@/components/specialEdition'
export default {
  data () {
    return {
      navBlock: '專輯  /  專輯列表',
      navtitle:'修改專輯',
      type:'edit',
      id: this.$route.query.id
    }
  },
  components: {
    NavBar,
    specialEdition
  }
};
</script>>



// WEBPACK FOOTER //
// src/pages/specialEdition/editSpecialEdition.vue